import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartsResponse } from './multiCartMappers'
import { arrayToObject } from 'lib/array/arrayUtils'
import qs from 'qs'
import type { MachineContext } from 'typings/app/machineContext'

type FetchSuccess = paths['/api/carts/multi-carts']['get']['responses']['200']['content']['application/json']

export async function getMultiCartSummaries(): Promise<MachineContext.CartSummary> {
  const queryParams = qs.stringify({ checkExistingOnly: 'false' })

  const response = await request.get<FetchSuccess>(`/api/carts/multi-carts?${queryParams}`, { credentials: 'include' })
  const cartSummaries = mapMultiCartsResponse(response)

  return arrayToObject(cartSummaries, item => item.cartId) as MachineContext.CartSummary
}
